<template>
	<div class="p-0 text-grey-900">
		<div
			class="plus-info-inner-wrapper bg-white border-1 border position-relative my-0 my-sm-5"
		>
			<!-- Title and icon -->
			<div class="d-flex justify-content-between">
				<div class="d-flex align-items-center">
					<div class="me-2">
						<component
							:is="props.advantage.cardTitleIcon"
							:width="32"
							:height="32"
						></component>
					</div>
					<div class="title-2 text-grey-900">{{ props.advantage.title }}</div>
				</div>
				<!-- Close button -->
				<button class="ts-x-black ts-x-md" @click="handleClose"></button>
			</div>

			<BorderHorizontal />
			<!-- Content -->
			<div
				class="shadow-3 border-1 border plus-info-inner-wrapper mb-4"
				v-for="(club, club_i) in state.infantClubs"
				:key="club_i"
			>
				<div class="d-flex flex-md-row flex-column">
					<div class="col-md-3 col-12 mb-md-0 mb-5">
						<div class="title-4 text-grey-900">{{ club.clubName }}</div>
						<div class="body text-grey-900" v-html="club.minAndMaxAge"></div>
					</div>
					<div class="col-md-9 col-12">
						<div class="body" v-html="club.activitiesDescription"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { onMounted } from "vue";

// State
import state from "@/vue/club-advantages/state/state";

// Classes
import { ClubAdvantage } from "@/vue/club-advantages/classes/ClubAdvantage";

// Components
import BorderHorizontal from "@/vue/common/borderHorizontal.vue";

// Props
const props = defineProps<{
	advantage: ClubAdvantage;
}>();

const emit = defineEmits<{
	(e: "closePopup"): void;
}>();

// Methods
const handleClose = (): void => {
	emit("closePopup");
};
</script>
